export const yinkaOrange = 0xEE9845;
export const yinkaDarkPink = 0xD55793;
export const yinkaLightPink = 0xDEBA5C0;
export const yinkaPurple = 0x725090;


export const colorPalette = [
0xC2A2C1,
0x2962A0,
0xFCDB88,
0x4A4387,
0xA08FB9,
0xE15231,
0x83CCCD,
0x0ABBE1,
0x8EC782,
0xAED7DA,
0xFCCE39,
0xEC9DBB,
0xF9D3B3,
0x66C2C9,
0xFAE771,
0xEB8735,
0xE38AB0,
0x4A4387,
0xC84C8C,
0x575593,
0xEB8A38,
0x6BB647,
0x3F8CBD,
0xE6756C,
0x3867A4,
0xE45F32,
0x80C26D,
0x725090,
0xA08FB9,
0xE77A5C,
0xEE9845,
0x0ABBE1,
0x1DAA7F,
0xDC4346,
0xD55793,
0xDFE15B,
0xF9C43C,
0x8D5F97,
0x299147,
0xD34F2D,
0xAED7DA,
0x506AA5,
0xFAE771,
0xEBA5C0,
0xEB8A38,
0x6BB647,
0x3F8CBD,
0xE6756C];


export default class YinkaColor{

  constructor(){}

  getRandom(){
    let i = Math.floor(Math.random() * colorPalette.length);
    return colorPalette[i];
  }

  getRandomGrass(){
    //1DAA7F
    let greens = [0x6BB647,0x80C26D,0x1DAA7F,0x299147,0x6BB647];
    let i = Math.floor(Math.random() * greens.length);
    return greens[i];
  }

  getDarkGreen(){
    return 0x1DAA7F;
  }

}
